import React from "react";
import { Helmet } from "react-helmet";
import SEOHead from "../components/SEOHead";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

import ImgCover from "../images/cover.jpg";
import ImgIntroduction from "../images/introduction.jpg";
import ImgHistory from "../images/history.jpg";
import ImgRND from "../images/rnd.jpg";
import ImgQC from "../images/qc.jpg";
import ImgMeetOurClients from "../images/meet_our_clients.jpg";
import ImgCertificates from "../images/certificates.jpg";
import ImgCertificatesIcons from "../images/certificates_icons.png";
import { Hidden } from "@material-ui/core";
import localizationManager from "./localizationManager";

const styles = (theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing.unit * 1,
    marginRight: theme.spacing.unit * 1,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  mainFeaturedPost: {
    // backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    marginBottom: theme.spacing.unit * 5,
    marginTop: theme.spacing.unit * 10,
    backgroundImage: `url(${ImgCover})`,
    backgroundPosition: "center left",
    backgroundSize: "cover",
  },
  darkenBox: {
    backgroundColor: "rgba(0,0,0,0.1)",
  },
  mainFeaturedPostContent: {
    padding: `${theme.spacing.unit * 10}px ${theme.spacing.unit * 5}px`,
    [theme.breakpoints.up("md")]: {
      paddingRight: 0,
    },
  },
  card: {
    // display: "flex",
    secondary: {
      main: "#E44A4B",
    },
    marginBottom: theme.spacing.unit * 5,
    [theme.breakpoints.down("sm")]: {
      width: "75%",
      marginLeft: "auto",
      marginRight: "auto",
      secondary: {
        main: "#E44A4B",
      },
      marginBottom: theme.spacing.unit * 5,
    },
  },
  cardDetails: {
    flex: 1,
    whiteSpace: "pre-line",
  },
  cardMedia: {
    width: "100%",
    height: theme.spacing.unit * 20,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    [theme.breakpoints.down("sm")]: {
      height: theme.spacing.unit * 30,
      marginTop: theme.spacing.unit * 2,
      marginLeft: "auto",
      marginRight: "auto",
      backgroundSize: "cover",
    },
  },
});

function Company(props) {
  const { classes } = props;

  const featuredPosts = [
    {
      title: localizationManager.getLocalString("@@introduction"),
      image: ImgIntroduction,
      description: localizationManager.getLocalString("@@introduction_desc"),
    },
    {
      title: localizationManager.getLocalString("@@history"),
      image: ImgHistory,
      description: localizationManager.getLocalString("@@history_desc"),
    },
    {
      title: localizationManager.getLocalString("@@research_&_development"),
      image: ImgRND,
      description: localizationManager.getLocalString(
        "@@research_&_development_desc"
      ),
    },
    {
      title: localizationManager.getLocalString("@@quality_control"),
      image: ImgQC,
      description: localizationManager.getLocalString("@@quality_control_desc"),
    },
    {
      title: localizationManager.getLocalString("@@global_clients"),
      image: ImgMeetOurClients,
      description: localizationManager.getLocalString("@@global_clients_desc"),
    },
    {
      title: localizationManager.getLocalString("@@certificates"),
      image: ImgCertificates,
      description: localizationManager.getLocalString("@@certificates_desc"),
    },
  ];

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.layout}>
        <main>
          <SEOHead
            title={localizationManager.getLocalStringPlain("@@seo_company_title")}
            description={localizationManager.getLocalStringPlain(
              "@@seo_company_description",
              {
                year: (new Date().getFullYear() - 1993).toString(),
              }
            )}
            lang={localizationManager.currentLang}
            location={props.location}
          />
          <Helmet>
            <meta property="og:title" content={localizationManager.getLocalStringPlain("@@seo_company_title")} />
            <meta property="og:description" content={localizationManager.getLocalStringPlain("@@seo_company_description", {
              year: (new Date().getFullYear() - 1993).toString(),
            })} />
            <meta property="og:type" content="website" />
            <meta
              property="og:image"
              content="http://dc-ac.com/images/history.jpg"
            />
          </Helmet>

          {/* Main featured post */}
          <Paper className={classes.mainFeaturedPost}>
            <Grid container className={classes.darkenBox}>
              <Grid item md={6}>
                <div className={classes.mainFeaturedPostContent}>
                  <Typography
                    variant="h4"
                    component="h1"
                    color="inherit"
                    gutterBottom
                  >
                    {localizationManager.getLocalString("@@linkchamp")}
                  </Typography>
                  <Typography variant="h5" color="inherit" paragraph>
                    {localizationManager.getLocalString("@@mission")}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Paper>
          {/* End main featured post */}

          <Grid container spacing={16}>
            {/* Introduction */}
            <Hidden smDown>
              <Grid item md={3}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[0].image}
                  />
                </Card>
              </Grid>
            </Hidden>
            <Grid item sm={12} md={9}>
              <Card className={classes.card}>
                <Hidden mdUp>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[0].image}
                  />
                </Hidden>
                <div className={classes.cardDetails}>
                  <CardContent>
                    <Typography component="h2" variant="h5">
                      {featuredPosts[0].title}
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                      {localizationManager.getLocalString(
                        "@@introduction-desc",
                        {
                          year: (new Date().getFullYear() - 1993).toString(),
                        }
                      )}
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
            {/* End of Introduction */}

            {/* History */}
            <Hidden smDown>
              <Grid item md={3}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[1].image}
                  />
                </Card>
              </Grid>
            </Hidden>
            <Grid item sm={12} md={9}>
              <Card className={classes.card}>
                <Hidden mdUp>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[1].image}
                  />
                </Hidden>
                <div className={classes.cardDetails}>
                  <CardContent>
                    <Typography component="h2" variant="h5">
                      {featuredPosts[1].title}
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                      {localizationManager.getLocalString("@@history-desc", {
                        year: (new Date().getFullYear() - 1993).toString(),
                      })}
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
            {/* End of History */}

            {/* RND */}
            <Hidden smDown>
              <Grid item md={3}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[2].image}
                  />
                </Card>
              </Grid>
            </Hidden>
            <Grid item sm={12} md={9}>
              <Card className={classes.card}>
                <Hidden mdUp>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[2].image}
                  />
                </Hidden>
                <div className={classes.cardDetails}>
                  <CardContent>
                    <Typography component="h2" variant="h5">
                      {featuredPosts[2].title}
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                      {localizationManager.getLocalString(
                        "@@research_&_development_desc",
                        {
                          year: (new Date().getFullYear() - 1993).toString(),
                        }
                      )}
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
            {/* End of RND */}

            {/* QC */}
            <Hidden smDown>
              <Grid item md={3}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[3].image}
                  />
                </Card>
              </Grid>
            </Hidden>
            <Grid item sm={12} md={9}>
              <Card className={classes.card}>
                <Hidden mdUp>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[3].image}
                  />
                </Hidden>
                <div className={classes.cardDetails}>
                  <CardContent>
                    <Typography component="h2" variant="h5">
                      {featuredPosts[3].title}
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                      {localizationManager.getLocalString(
                        "@@quality_control_desc",
                        {
                          year: (new Date().getFullYear() - 1993).toString(),
                        }
                      )}
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
            {/* End of QC */}

            {/* Global Clients */}
            <Hidden smDown>
              <Grid item md={3}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[4].image}
                  />
                </Card>
              </Grid>
            </Hidden>
            <Grid item sm={12} md={9}>
              <Card className={classes.card}>
                <Hidden mdUp>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[4].image}
                  />
                </Hidden>
                <div className={classes.cardDetails}>
                  <CardContent>
                    <Typography component="h2" variant="h5">
                      {featuredPosts[4].title}
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                      {localizationManager.getLocalString(
                        "@@global_clients_desc",
                        {
                          year: (new Date().getFullYear() - 1993).toString(),
                        }
                      )}
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
            {/* End of Global Clients */}

            {/* Certificates */}
            <Hidden smDown>
              <Grid item md={3}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[5].image}
                  />
                </Card>
              </Grid>
            </Hidden>
            <Grid item sm={12} md={9}>
              <Card className={classes.card}>
                <Hidden mdUp>
                  <CardMedia
                    className={classes.cardMedia}
                    image={featuredPosts[5].image}
                  />
                </Hidden>
                <div className={classes.cardDetails}>
                  <CardContent>
                    <Typography component="h2" variant="h5">
                      {featuredPosts[5].title}
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                      {localizationManager.getLocalString(
                        "@@certificates_desc",
                        {
                          year: (new Date().getFullYear() - 1993).toString(),
                        }
                      )}
                    </Typography>
                    <img
                      src={ImgCertificatesIcons}
                      style={{ width: "70%", height: "50%" }}
                      alt="certificateIcons"
                      title="Certificates"
                      loading="lazy"
                    />
                  </CardContent>
                </div>
              </Card>
            </Grid>
            {/* End of Certificates */}
          </Grid>
        </main>
      </div>
    </React.Fragment>
  );
}

Company.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Company);
